import script from "./ApproveModuleForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ApproveModuleForm.vue?vue&type=script&setup=true&lang=js"

import "./ApproveModuleForm.vue?vue&type=style&index=0&id=27b72646&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27b72646"]])

export default __exports__